import React, { useEffect, useState } from "react";
import moment from "moment";
import { truncateText } from "../../../utils/handlers";

const RegistrationDetails = ({ vehicle }) => {
  return (
    <>
      <p className="  font-bold text-[22px] text-[#262626]">
        Registration Details
      </p>

      <div className="w-[380px] px-4 py-4 mt-4  rounded-lg h-fit flex flex-col border border-[#e6ebed]">
        {/* <div className="flex flex-row justify-between items-center cursor-pointer">
        <p>Registration Details</p>
      </div> */}
        <>
          <div className="flex flex-row justify-between items-center">
            <div className="flex flex-col justify-start ">
              <p className="text-xs font-medium text-[#848484] mb-[6px]">
                Owner Name
              </p>
              <p className="text-xs font-bold text-[#262626] text-end">
                {vehicle?.owner_name || "---"}
              </p>
            </div>
            <div
              className="flex flex-col justify-start "
              style={{ textAlign: "end" }}
            >
              <p className="text-xs font-medium text-[#848484] mb-[6px]">
                Registration Date
              </p>
              <h5 className="text-[#262626] text-xs font-bold">
                {" "}
                {moment(
                  vehicle &&
                    vehicle?.registration_details &&
                    vehicle?.registration_details?.date,
                  "DD/MM/YYYY"
                ).format("ll")}
              </h5>
            </div>
          </div>
          <div
            className="flex flex-row justify-between items-center"
            style={{ marginTop: "12px" }}
          >
            <div className="flex flex-col justify-start">
              <p className="text-xs font-medium text-[#848484] mb-[6px]">
                Registered RTO
              </p>
              <h5
                title={
                  vehicle &&
                  vehicle?.registration_details &&
                  vehicle?.registration_details?.authority
                }
                className="text-xs font-bold text-[#262626] capitalize"
              >
                {vehicle &&
                  vehicle?.registration_details &&
                  truncateText(vehicle?.registration_details?.authority, 30)}
              </h5>
            </div>
            <div
              className="flex flex-col justify-start "
              style={{ textAlign: "end" }}
            >
              <p className="text-xs font-medium text-[#848484] mb-[6px]">
                RC Fit Upto
              </p>
              <h5 className="text-[#262626] text-xs font-bold">
                {" "}
                {moment(
                  vehicle &&
                    vehicle?.registration_details &&
                    vehicle?.registration_details?.expiryDate,
                  "DD/MM/YYYY"
                ).format("ll")}
              </h5>
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default RegistrationDetails;
